var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container button",class:{ loading: _vm.loading }},[_c('input',{style:({ backgroundColor: _vm.color }),attrs:{"id":_vm.id,"type":"button","disabled":_vm.loading,"value":_vm.label},on:{"click":_vm.validate}})])
}
var staticRenderFns = []

export { render, staticRenderFns }